<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <!-- 主内容 -->
    <div class="aboutboxxq">
      <div class="content">
        <div class="about_contxt rojbg">
          <div class="about_cont1">
            <!-- <img :src="base_url+configList.contact_image"> -->
            <img src="/static/images/contact/contact.png">
            <div class="about_txt">
              <h4 v-if="contactInfo.company_name">{{contactInfo.company_name}}</h4>
              <i v-if="contactInfo.company_name"></i>
              <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.telephone">电话：</h5>
              <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.telephone">{{contactInfo.telephone}}</p>
              <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.post_code">邮编：</h5>
              <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.post_code">{{contactInfo.post_code}}</p>
              <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.company_url">网址：</h5>
              <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.company_url">{{contactInfo.company_url}}</p>
              <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.address">地址：</h5>
              <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.address">{{contactInfo.address}}</p>
            </div>
          </div>
        </div>
        <div class="about_txt1">
          <ul>
            <li class="rojbg">
              <div class="about_txta">
                <h4 v-if="contactInfo.presale_telephone">售前服务信息</h4>
                <i v-if="contactInfo.presale_telephone"></i>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_telephone">电话：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_telephone">{{contactInfo.presale_telephone}}</p>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_phone">手机：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_phone">{{contactInfo.presale_phone}}</p>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_email">邮箱：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.presale_email">{{contactInfo.presale_email}}</p>
              </div>
            </li>
            <li class="rojbg">
              <div class="about_txta">
                <h4 v-if="contactInfo.aftersale_telephone">售后服务信息</h4>
                <i v-if="contactInfo.aftersale_telephone"></i>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_telephone">电话：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_telephone">{{contactInfo.aftersale_telephone}}</p>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_phone">手机：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_phone">{{contactInfo.aftersale_phone}}</p>
                <h5 style="padding:0px;margin:10px 0px 0px;font-weight:400;color:#999999;font-size:16px;line-height:25px;font-family:white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_email">邮箱：</h5>
                <p style="padding:0px;margin-top:0px;margin-bottom:0px;line-height:30px;color:#333333;font-family:font-size:14px;white-space:normal;background-color:#ffffff;" v-if="contactInfo.aftersale_email">{{contactInfo.aftersale_email}}</p>
              </div>
            </li>
            <li class="rojbg">
              <div class="about_txta"><h4>微信公众号</h4><i></i><p><br></p>
                <p style="text-align:center;">
                  <!-- <img class="wechat-image" :src="base_url+configList.wechat_image"> -->
                  <img class="wechat-image" src="/static/images/foot/wechat.png">
                </p>
                <p><br></p>
                <p><br></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('@/common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;

  export default {
    data () {
      return {
        base_url: base_url,//base_url
        contactInfo: [],//关于联系我们列表
      }
    },
    created: function () {
    	var that = this;

    	//获取配置信息列表
    	that.getConfigList();
    },
    methods: {

      //获取配置信息
      getConfigList:function(){
        var that = this;
        axios.post(base_url+'front/getConfigList', {'group': null}).then(function (res) {
          //console.log(res);
          if(res.data.code == 0){
            var dataList = res.data.result;
            var configList = [];
            for (var i=0;i<dataList.length;i++) {
              var itemKey = dataList[i]['itemKey'];
              var itemValue = dataList[i]['itemValue'];
              configList[itemKey] = itemValue;
            }
            //console.log(configList);
            that.contactInfo = configList;
          }
        }).catch(function (err) {
          //console.log(err);
        })
      },

    }
  }
</script>

<style scoped>
  @import url("./contact.css");
</style>



// WEBPACK FOOTER //
// src/views/contact/contact.vue